import React from 'react'
import { Card, Typography } from '@mui/material'

interface NoRowsProps {}

export const NoRows: React.FC<NoRowsProps> = () => {
  return (
    <Card
      style={{
        display: 'flex',
        padding: 30,
        alignContent: 'center',
        justifyContent: 'center'
      }}
    >
      <Typography variant='subtitle2'>No rows</Typography>
    </Card>
  )
}
